<template>
  <van-popup v-model="show" class="bind__phone" closeable duration="0.05" @close="close">
    <div class="bindPhone">
      <!-- <img src="https://img.yzcdn.cn/upload_files/2020/06/04/FnHNkAkYPW88e050PL8U-XXkKQ9q.png" /> -->
      <!-- <div class="bindPhone-close" @click="show = false"></div> -->
      <div class="content flex-col flex-al-center">
        <p v-if="type !== 5" class="title">绑定手机</p>
        <p v-if="type == 5" class="title">完成验证再领<span style="color:red;">3天</span>SVIP</p>
        <div v-if="type === 0">
          <div class="title2__box">
            <p class="title2">
              <span>根据</span>
              <em>《中华人民共和国网络安全法》</em>
              <br />
              <span>要求，为保障您的使用体验，建议尽</span>
              <br />
              <span>快完成</span>
              <em>手机号绑定验证</em>
              <span>，感谢您的理</span>
              <br />
              <span>解与支持。</span>
            </p>
          </div>
          <div class="button" @click="toBindPhone">去绑定</div>
        </div>
        <div v-else-if="type === 1">
          <div class="title2__box">
            <p class="title2">
              <span>检测到手机号绑定了多个账户，</span>
              <br />
              <span>请验证</span>
              <em>身份</em>
              <span>或绑定</span>
              <em>新手机号</em>
              <span>。</span>
            </p>
          </div>
          <div class="buttons">
            <div class="button" @click="toVerifyPhone">验证身份</div>
            <div class="button" @click="toBindPhone">重新绑定</div>
          </div>
        </div>
        <div v-else-if="type === 2">
          <div class="title2__box">
            <p class="title2">
              <span>检测到您的手机号绑定了多个账户，</span>
              <br />
              <span>已为您解绑。为保障</span>
              <em>账户安全</em>
              <span>，</span>
              <br />
              <span>请立即</span>
              <em>重新绑定</em>
              <span>，感谢您的理解。</span>
            </p>
          </div>
          <div class="button" @click="toBindPhone">绑定新手机号</div>
        </div>
        <div v-else-if="type === 3">
          <div class="title2__box">
            <p class="title2">
              <span>账户绑定</span>
              <em>移动</em>
              <span>手机号后才能</span>
              <em>兑换</em>
              <span>哦~</span>
            </p>
          </div>
          <div class="button" @click="BindPhoneLin">绑定手机号</div>
        </div>
        <div v-else-if="type === 4">
          <div class="title2__box">
            <p class="title2">
              <span>检测到您的手机号绑定了多个账户，</span>
              <br />
              <span>为保障</span>
              <em>账户安全</em>
              <span>，需要</span>
              <em>重新验证后</em>
              <span>，</span>
              <br />
              <span>才能兑换哦～</span>
            </p>
          </div>
          <div class="button" @click="VerifyPhone">去验证</div>
        </div>
        <div v-else-if="type === 5">
          <div class="title2__box">
            <p class="title2">
              <span>根据</span>
              <em>《中华人民共和国网络安全法》</em>
              <br />
              <span>要求，为了保障您的使用体验，建议</span>
              <br />
              <span>尽快完成</span>
              <em>绑定手机号</em>
              <span>验证。</span>
            </p>
          </div>
          <div class="button" @click="toBindPhone">
            <img
              src="https://img01.yzcdn.cn/upload_files/2021/03/23/FnApD_NsECDEwGQIZquyRoyk9mUM.png"
            />
          </div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { register } from '@/plugin/popup'
export default {
  data() {
    return {
      show: false,
      type: 0
    }
  },
  mounted() {
    register({
      name: 'BindPhone',
      open: ({ afterClose, type }) => {
        this.afterClose = afterClose
        this.type = type
        this.show = true
      },
      close: () => {
        this.close()
      }
    })
  },
  methods: {
    toBindPhone() {
      location.href = '/cms/webapp/home/user/userCenter.html#/bindPhoneNumber?bind=1'
    },
    toVerifyPhone() {
      location.href = '/cms/webapp/home/user/userCenter.html#/verifyPhoneNumber'
    },
    BindPhoneLin() {
      location.href = '/cms/webapp/home/user/userCenter.html#/bindPhoneNumber?bind=1'
      this.show = false
    },
    VerifyPhone() {
      location.href = '/cms/webapp/home/user/userCenter.html#/verifyPhoneNumber'
      this.show = false
    },
    close() {
      this.show = false
      if (this.afterClose) {
        this.afterClose()
      }
    }
  }
}
</script>

<style lang="scss">
.bind__phone.van-popup {
  background-color: transparent;
  margin-top: -1.65rem;
}
.bind__phone .van-popup__close-icon--top-right {
  position: absolute;
  top: 2.96rem;
  right: 0.44rem;
  font-size: 0.4rem;
}
</style>
<style lang="scss" scoped>
.bindPhone {
  position: relative;
  width: 7.51rem;
  padding-top: 3.3rem;
  background-image: url(https://img.yzcdn.cn/upload_files/2020/06/04/FnHNkAkYPW88e050PL8U-XXkKQ9q.png);
  background-size: contain;
  background-repeat: no-repeat;

  img {
    display: block;
    width: 100%;
  }
  .bindPhone-close {
    position: absolute;
    // bottom: 5.73rem;
    right: 0.44rem;
    width: 0.4rem;
    height: 0.4rem;
    z-index: 1;
  }
  .content {
    background: #fff;
    border-radius: 0 0 0.2rem 0.2rem;
    padding-top: 0.3rem;
    padding-bottom: 0.68rem;
    & > div {
      width: 100%;
    }
    .title {
      font-size: 0.43rem;
      font-weight: bold;
      color: rgba(0, 0, 0, 1);
    }
    .title2__box {
      display: flex;
      justify-content: center;
    }
    .title2 {
      margin-top: 0.54rem;
      display: inline-block;
      font-size: 0.4rem;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
      line-height: 0.6rem;
      em {
        font-style: normal;
        color: #ef4246;
      }
    }
    .buttons {
      display: flex;
      padding-left: 0.72rem;
      padding-right: 0.72rem;
      justify-content: space-between;
      .button {
        margin: 0.89rem 0 0 0;
        width: 2.83rem;
      }
    }
    .button {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      margin-top: 0.89rem;
      width: 5.44rem;
      height: 1.09rem;
      background: rgba(239, 66, 70, 1);
      box-shadow: 0px 3px 9px 1px rgba(239, 66, 70, 0.5);
      border-radius: 1rem;
      font-size: 0.4rem;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      img {
        width: 204px;
        height: 40px;
      }
    }
  }
}
</style>
